<script>
export default {
  props: {
    definition: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
